export enum MovementStatus {
  Unknown = 0,
  Draft = 1,
  ReadyForMovement = 2,
  InProgress = 3,
  Completed = 4,
  Cancelled = 5,
}

export enum LicensePlateAssociationName {
  Unknown = 0,
  Store = 1,
  Warehouse = 2,
}

export enum LicensePlateStatus {
  Unknown = 0,
  InUse,
  Relocating,
  Available,
  TransferPending,
  InTransit,
}

export enum Status {
  Unknown = 0,
  Active = 1,
  Inactive = 2,
}

export enum LabelEntityType {
  Unknown = 0,
  Product = 1,
  Container = 2,
}

export const PageSizes: number[] = [15, 30, 45];